import type { EventHandlerCallback } from "../engines/coreComponents/types";
import { DragType } from "../engines/interactionEngine/interactionObserverConstants";
import type { FSC } from "../engines/renderingEngine/fsc.types";
import {
  BoxNode,
  IconNode,
  TextNode
} from "../engines/renderingEngine/primitiveNodes";
import { VERTICAL_DROP_INDICATOR_WIDTH } from "./VerticalDropIndicator";
import { PALETTE, THEME } from "./colorPalette.constants";
import { styles } from "./scomponents.styles";

type AddSwimlaneProps = {
  key: string;
  onDropped?: EventHandlerCallback;
  onDropping?: EventHandlerCallback;
  onDroppingOut?: EventHandlerCallback;
  onClick: EventHandlerCallback;
  theme?: THEME;
  isDroppingAbove?: boolean;
};

export const AddSwimlane: FSC<AddSwimlaneProps> = ({
  key,
  onDropped,
  onDropping,
  onDroppingOut,
  onClick,
  isDroppingAbove,
  theme = THEME.LIGHT
}) => {
  const style = styles[theme].addSwimlane;
  const palette = PALETTE[theme];
  const addFieldNode = BoxNode({
    key: `${key}`,
    style: isDroppingAbove
      ? {
          ...style.container,
          marginLeft:
            (style.container.marginLeft ?? 0) - VERTICAL_DROP_INDICATOR_WIDTH
        }
      : style.container,
    // dragType: "field",
    dropTypes: [DragType.SWIMLANE],
    // dragHandleFor: key,
    eventHandlers: {
      onClick,
      onDropped,
      onDropping,
      onDroppingOut
    },
    // onDragStart,
    children: [
      BoxNode({
        key: `${key}-Box`,
        style: style.textContainer,
        children: [
          IconNode({
            key: `${key}-Icon`,
            icon: "PlusLight",
            size: 16,
            color: palette.ADD_SWIMLANE_COLOR,
            children: []
          }),
          TextNode({
            key: `${key}-Text`,
            text: "Add swimlane",
            textStyle: style.titleText,
            style: style.titleContainer,
            children: []
          })
        ]
      })
    ]
  });

  return addFieldNode;
};
